import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=e970b022"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=e970b022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports